import { batch } from 'react-redux';
import { HIDDEN_PARTICIPANT_JOINED, HIDDEN_PARTICIPANT_LEFT, PARTICIPANT_UPDATED } from '../base/participants/actionTypes';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { showErrorNotification } from '../notifications/actions';
import { toggleRequestingSubtitles } from '../subtitles/actions.any';
import { TRANSCRIBER_JOINED, TRANSCRIBER_LEFT, _TRANSCRIBER_JOINED, _TRANSCRIBER_LEFT } from './actionTypes';
import { hidePendingTranscribingNotification, potentialTranscriberJoined, showStoppedTranscribingNotification, showStartedTranscribingNotification, transcriberJoined, transcriberLeft } from './actions';
import './subscriber';
const TRANSCRIBER_DISPLAY_NAME = 'Transcriber';
/**
 * Implements the middleware of the feature transcribing.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    const { transcriberJID, potentialTranscriberJIDs } = getState()['features/transcribing'];
    switch (action.type) {
        case TRANSCRIBER_LEFT:
        case _TRANSCRIBER_LEFT: {
            dispatch(showStoppedTranscribingNotification());
            const state = getState();
            const { transcription } = state['features/base/config'];
            const { _requestingSubtitles } = state['features/subtitles'];
            if (action.abruptly) {
                dispatch(showErrorNotification({
                    titleKey: 'transcribing.failed'
                }));
            }
            if (_requestingSubtitles && !transcription?.disableStartForAll) {
                dispatch(toggleRequestingSubtitles());
            }
            break;
        }
        case HIDDEN_PARTICIPANT_JOINED:
            if (action.displayName
                && action.displayName === TRANSCRIBER_DISPLAY_NAME) {
                dispatch(transcriberJoined(action.id));
            }
            else {
                dispatch(potentialTranscriberJoined(action.id));
            }
            break;
        case HIDDEN_PARTICIPANT_LEFT:
            if (action.id === transcriberJID) {
                dispatch(transcriberLeft(action.id));
            }
            break;
        case PARTICIPANT_UPDATED: {
            const { participant } = action;
            if (potentialTranscriberJIDs && Array.isArray(potentialTranscriberJIDs)
                && potentialTranscriberJIDs.includes(participant.id)
                && participant.name === TRANSCRIBER_DISPLAY_NAME) {
                batch(() => {
                    dispatch(transcriberJoined(participant.id));
                    dispatch(hidePendingTranscribingNotification());
                });
            }
            break;
        }
        case TRANSCRIBER_JOINED:
        case _TRANSCRIBER_JOINED: {
            dispatch(showStartedTranscribingNotification());
            const state = getState();
            const { transcription } = state['features/base/config'];
            const { _requestingSubtitles } = state['features/subtitles'];
            if (!_requestingSubtitles && !transcription?.disableStartForAll) {
                dispatch(toggleRequestingSubtitles());
            }
            break;
        }
    }
    return next(action);
});
